import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


import { Notification, NotificationType } from "@/stores/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainNotification',
  props: {
  notification: Notification,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.notification)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["notification", _unref(NotificationType)[__props.notification.type]])
      }, _toDisplayString(__props.notification.text), 3))
    : _createCommentVNode("", true)
}
}

})